"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _AsyncRequest = _interopRequireDefault(require("../AsyncRequest"));

var _configActionKeys = _interopRequireDefault(require("./configActionKeys"));

var _default = _AsyncRequest.default.createReducer(_configActionKeys.default.GET_DYNAMIC_CONFIG, {});

exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/angieslist-app-platform/lib/common/dynamicConfig/configReducer.js
// module id = 4428
// module chunks = 25